import { useEffect, useState } from 'react';
import { apiFetch } from '../api/client.ts';
import { DEFAULT_HIDDEN_TICKET_STATUSES } from '@t3/shared';
import type { TicketStatus } from '@t3/shared';

// Module-scoped cache so multiple pages don't refetch. Settings change
// rarely; a fresh page load picks up admin edits.
let cached: TicketStatus[] | null = null;
let inflight: Promise<TicketStatus[]> | null = null;

async function fetchHidden(): Promise<TicketStatus[]> {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = apiFetch<{ hiddenTicketStatuses: TicketStatus[] }>('/api/settings/agent')
    .then((r) => {
      cached = r.hiddenTicketStatuses;
      return cached;
    })
    .catch(() => {
      cached = [...DEFAULT_HIDDEN_TICKET_STATUSES];
      return cached;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function invalidateHiddenStatuses(): void {
  cached = null;
}

export function useHiddenStatuses(): Set<TicketStatus> {
  const [list, setList] = useState<TicketStatus[]>(() => cached ?? [...DEFAULT_HIDDEN_TICKET_STATUSES]);
  useEffect(() => {
    let mounted = true;
    void fetchHidden().then((v) => {
      if (mounted) setList(v);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return new Set(list);
}
